let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jWWt8")).then(() => parcelRequire('ksMlh'));